import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const baseConfig = {
  key: 'job.checkpoints',
  storage
};

const persistReducerOnClient = (key, reducer, config) => {
  //eslint-disable-next-line no-undef
  if (typeof SERVER === 'undefined' || SERVER) {
    return reducer;
  }
  return persistReducer({ ...baseConfig, key, ...config }, reducer);
};

export default persistReducerOnClient;
